import {
  resolveLocationByHost,
  resolveLocationByPathname,
} from "@/lib/restaurant-platform";

const EXCLUDED_PATHS = [
  "/menu",
  "/order",
  "/catering",
  "/private-events",
  "/reservations",
  "/locations",
  "/redeem",
  "/terms",
  "/privacy",
  "/accessibility",
  "/unsubscribe",
  "/jobs",
  "/gaming",
  "/food-menu",
  "/henderson-mcdonald-highlands-chef-s-roma-kitchen-food-menu-117301",
] as const;

type PublicPopupGateInput = {
  popupEnabled: boolean;
  pathname: string | null | undefined;
  publicHost: string | undefined;
};

function isExcludedPath(pathname: string): boolean {
  return EXCLUDED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function shouldRenderEmailCapturePopup({
  popupEnabled,
  pathname,
  publicHost,
}: PublicPopupGateInput): boolean {
  if (!popupEnabled) return false;
  if (!pathname) return false;
  if (!publicHost) return false;
  if (isExcludedPath(pathname)) return false;

  const publicLocation =
    resolveLocationByPathname(pathname) ?? resolveLocationByHost(publicHost);

  if (!publicLocation) return false;

  const homepagePopupRestaurantIds = new Set(["tuscan-cove", "roma-kitchen"]);
  if (
    pathname === "/" &&
    !homepagePopupRestaurantIds.has(publicLocation.restaurantId)
  ) {
    return false;
  }

  return true;
}
